import { BrowserRouter } from "react-router-dom";
import {
  MideyeAppAuthProvider,
  type MideyeAuthorize,
} from "@mideye/auth-react";
import App from "./App.tsx";
import { API_PORTAL_APP_NAME, ApiPortalIcon } from "./appIdentity";
import { api, clearAuthState, setTokenGetter } from "./lib/api";
import { AuthProvider } from "./lib/AuthProvider";
import type { UserInfo } from "./types/api";

const authorizeApiPortalAccess: MideyeAuthorize<UserInfo> = ({ user }) => {
  if (user.company_id) return true;

  return {
    reason: "missing-company",
    title: "Account setup required",
    message:
      "Your account has been created successfully, but it hasn't been assigned to a company yet.",
    requiredAccess: ["Company assignment"],
    supportHref:
      "mailto:support@mideye.com?subject=Mideye%20API%20Portal%20access",
    supportLabel: "Request setup",
  };
};

export default function AppWithAuth() {
  return (
    <MideyeAppAuthProvider<UserInfo>
      appName={API_PORTAL_APP_NAME}
      appIcon={<ApiPortalIcon />}
      host={{
        getConfig: api.getAuthConfig,
        getMe: api.getMe,
        setTokenGetter,
        clearAuthState,
        clearBackendSession: () => api.logout(),
      }}
      getUserEmail={(user) => user.email}
      authorize={authorizeApiPortalAccess}
      configCacheKey="shield_auth_config"
    >
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </MideyeAppAuthProvider>
  );
}
